<h2 mat-dialog-title>Help for Interactive Graphs</h2>
<mat-dialog-content>
  <h3 style="text-align: left;">All Users:</h3>
  <p>
    Graphs cannot be directly manipulated, unless otherwise specified. Graph interaction is via controls such as sliders, buttons and checkboxes.
  </p>
  <h3 style="text-align: left;">Screen Reader Users:</h3>
  <p>
    Use the tab key to explore the graph. Pressing the space bar will give more detailed information about the object. Use the escape key to exit the graph. When math is selected, pressing the space bar will open an accessible contextual menu. There are a number of useful settings for exploring math.
  </p>
  <h3 style="text-align: left;">Keyboard Users:</h3>
  <p>
    Exploring the graph with the tab key provides no information for keyboard users. Use the escape key to exit the graph. For a better experience, you can change slider values in 10-step increments by using the page up and page down keys. When math is selected, pressing the space bar will open an accessible contextual menu. There are a number of useful settings for exploring math.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
